import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';

const queryFn = (params: QueryParams) => {
    return network.post<QueryFnResponse>('api/bo/getCrossVersionsTrends', params).then((response) => response.data);
};

export const useQueryGetCrossVersionsTrends = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getCrossVersionsTrends', params],
        queryFn: () => queryFn(params),
        enabled: params?.ids.filter(Boolean).length > 0,
    });
};

interface QueryParams {
    ids: number[];
}

interface QueryFnResponse {
    actual: {
        graph: {
            [key: string]: {
                title: string;
                seriesname: string;
                data: [
                    {
                        text: string;
                        displayValue: string;
                        label: number;
                        value: number;
                        actualValue: number;
                    }[],
                ];
                color: string;
                selectedByDefault: boolean;
            };
        };
        info: IToolTip;
    };
    normalized: {
        graph: {
            [key: string]: {
                title: string;
                seriesname: string;
                data: [
                    {
                        text: string;
                        displayValue: string;
                        label: number;
                        value: number;
                        actualValue: number;
                    }[],
                ];
                color: string;
                selectedByDefault: boolean;
            };
        };
        info: IToolTip;
    };
}

type QueryResponse = QueryFnResponse & {};
